import { checkPermission } from '@/router/guards.ts'

const QuestionModule = () => import('./QuestionModule.vue')
const QuestionIndex = () => import('./views/QuestionIndex.vue')

export const questionRoute = {
  path: '/questions',
  name: 'question',
  component: QuestionModule,
  meta: {
    title: 'Questions',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: '',
      name: 'questions-index',
      component: QuestionIndex,
      meta: {
        permission: 'security_question.view',
      },
      beforeEnter: checkPermission('security_question.view'),
    },
  ],
}
